import useApp from './useApp';
import LoadingWrapper from '../../components/Loading/LoadingWrapper';

function AppLoading({ children, loadingComponent }: AppLoadingProps) {
  const { loading } = useApp();

  return (
    <LoadingWrapper loadingComponent={loadingComponent} loading={loading}>
      {children}
    </LoadingWrapper>
  );
}

export default AppLoading;
